import React from 'react';
import FilterPlain from '../FilterPlain/FilterPlain';
import FilterPopup from '../FilterPopup/FilterPopup';
import { GroupOfFieldCheckboxes } from '../SelectMultipleFilter/SelectMultipleFilter';
import { ActiveFilters } from '../../../components';

import css from './FilterPlainPopup.module.css';

const FilterPlainPopup = props => {
  const { popupProps, groupProps, activeFilterProps, ...rest } = props;
  return (
    <FilterPlain
      {...rest}
      popup={
        <FilterPopup {...popupProps} className={css.popup}>
          <GroupOfFieldCheckboxes {...groupProps} />
        </FilterPopup>
      }
    >
      <ActiveFilters {...activeFilterProps} />
    </FilterPlain>
  );
};

export default FilterPlainPopup;
